import { FC, useEffect, useRef } from "react";
import { useApp } from "../../../context/useApp";
import { ShiftSelection } from "../../ShiftSelection";
import { ProductsSelection } from "../../ProductsSelection";
import { Summary } from "./Summary";
import { _ } from "../../../utils/helpers";
import { Zones } from "./Zones";
import { ROUTES, SCREEN_BREAKPOINT_2 } from "../../../utils/symbols";

export const Aside: FC = () => {

    const {
        state: {screen, booking, forcedRenders },
        actions: { navigate }
    } = useApp()

    const asideContentRef = useRef<HTMLDivElement>(null)
    const lastBookingStep = useRef(booking.step)
    
    const renderShiftSelction = (booking.step === 'shift')
    const renderZones = (booking.step === 'tickets')
    const renderProductsSelection = (['products', 'personal-details', 'payment'].includes(booking.step))
    const renderSummary = (['tickets', 'products'].includes(booking.step))

    useEffect(() => {
        
        //reset aside scroll to top when changing step
        if (booking.step !== lastBookingStep.current && asideContentRef.current)
            asideContentRef.current.scrollTo({top: 0, left: 0, behavior: 'smooth'})

        lastBookingStep.current = booking.step

    }, [forcedRenders])

    return (
        <>
        <div 
            className="df fd-c aifs aside pb-12 h-100 p-r" 
            // aria-label={ariaLabel}
        >
            <div ref={asideContentRef} className="w-100 h-100 aside-content px-10">
                {renderShiftSelction && (<ShiftSelection />)}
                {renderZones && (<Zones />)}
                {renderProductsSelection && (<ProductsSelection />)}
            </div>
        </div>
        {renderSummary && (<Summary />)}
        </>
    )
}